import React from 'react';

const ComingSoonText = () => {
  return (
    <div className="coming-soon-wrapper">
      <p>Coming soon...</p>
    </div>
  );
};

export default ComingSoonText;



/** WEBPACK FOOTER **
 ** ./src/components/coming-soon-text/index.js
 **/